var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 11.8L2 22.5L12.7 18.71M4 3.5H4.01M22 8.5H22.01M15 2.5H15.01M22 20.5H22.01M22 2.5L19.76 3.25C19.1224 3.46239 18.5783 3.88964 18.2208 4.45872C17.8633 5.02781 17.7146 5.70339 17.8 6.37C17.9 7.23 17.23 8 16.35 8H15.97C15.11 8 14.37 8.6 14.21 9.44L14 10.5M22 13.5L21.18 13.17C20.32 12.83 19.36 13.37 19.2 14.28C19.09 14.98 18.48 15.5 17.77 15.5H17M11 2.5L11.33 3.32C11.67 4.18 11.13 5.14 10.22 5.3C9.52 5.4 9 6.02 9 6.73V7.5",
    stroke: "#8F0DED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 13.5005C12.9295 15.4305 13.8295 17.6705 12.9995 18.5005C12.1695 19.3305 9.92953 18.4305 7.99953 16.5005C6.06953 14.5705 5.16953 12.3305 5.99953 11.5005C6.82953 10.6705 9.06953 11.5705 10.9995 13.5005Z",
    stroke: "#8F0DED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.38130973eb52a842a28d227373e0408d.svg";
export { ForwardRef as ReactComponent };